import styled from 'styled-components';
import { DEVICES } from '_constants';
import { UiColors } from 'assets/styles/old/global';
import { Button } from '../styles/button.style';
import InputSearch from '../inputSearch';

const Wrapper = styled.div.attrs(() => ({ ariaRequired: true }))`
  width: 100%;
  @media print {
    display: none !important;
  }
`;

const FormWrapper = styled.form.attrs(() => ({
  ariaRequired: true,
}))`
  display: flex;
  margin-right: 18px;

  /* New design: the field and its Search button read as one control -- matching heights, and the
     seam between them unrounded. Scoped to this form rather than declared as a global
     ".form_search" rule so that standalone search inputs elsewhere (the map features panel, for
     one) keep their fully rounded corners. modules/ListScaffold's newUiSearchField declares the
     same shape for the toolbars that opt into it. */
  html[data-new-ui='true'] & {
    align-items: stretch;

    .form_search {
      border-radius: 8px 0 0 8px;
      border-right: none;
    }

    .searchButton {
      align-self: stretch;
      border-radius: 0;
    }

    /* Whichever control ends the group rounds the right edge -- the Search button itself, or the
       advanced-search caret when one follows it (see AdvancedCaretButton below). */
    .searchButton:last-child {
      border-top-right-radius: 8px;
      border-bottom-right-radius: 8px;
    }
  }
`;

const WrapperSearchingGroup = styled.div.attrs(() => ({
  ariaRequired: true,
}))`
  display: flex;
  margin-right: 18px;
`;

const WrapperBlock = styled.div.attrs(() => ({ ariaRequired: true }))`
  display: flex;

  @media ${DEVICES.mobileL} {
    ${({ type }) => type !== 'button' && `flex-direction:column`};
  }
`;

const SearchButton = styled(Button)`
  width: 70px;
  padding: 12px 14px;
  background: ${UiColors.notificationBackgroundColor};
  font-family: Roboto;
  font-size: 14px;
  padding: 12px 14px;
  box-sizing: border-box;

  @media ${DEVICES.mobileL} {
    width: 64px;
    height: 36px;
    font-size: 14px !important;
  }

  &:focus {
    border: 1px solid ${(props) => (props.isActive ? UiColors.activeBorder : UiColors.focusColor)};
    outline-color: ${UiColors.focusColor} !important;
  }
`;

const Input = styled(InputSearch)`
  background: ${UiColors.alabasterFillColor} !important;
  border: 1px solid ${UiColors.alabasterFillColor} !important;

  @media ${DEVICES.mobileL} {
    width: 132px !important;
    padding: 0;
  }
`;

const WrapperSelect = styled.div`
  width: 240px;
`;

const SearchButtonGroup = styled.div`
  display: inline-flex;
  align-items: stretch;
`;

const AdvancedCaretButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 3px;
  height: 39px;
  width: 48px;
  padding: 0 4px;
  margin: 0;
  border: 0;
  background-color: ${UiColors.mangoColor};
  color: ${UiColors.forestColor};
  line-height: 1;
  cursor: pointer;
  border-radius: 1px;
  transition: filter 0.2s;
  filter: ${({ isActive }) => (isActive ? 'saturate(2)' : 'none')};

  /* Closes the search group: square where it butts against the Search button, rounded on the
     outer edge, and stretched to the field's height like the button beside it. */
  html[data-new-ui='true'] & {
    height: auto;
    align-self: stretch;
    border-radius: 0 8px 8px 0;
  }

  &:hover {
    filter: saturate(2);
  }

  &:focus {
    outline: 2px solid ${UiColors.focusColor};
    outline-offset: -2px;
  }

  svg {
    display: block;
  }

  @media ${DEVICES.mobileL} {
    width: 42px;
  }
`;

export {
  Wrapper,
  WrapperBlock,
  SearchButton,
  WrapperSearchingGroup,
  Input,
  WrapperSelect,
  FormWrapper,
  SearchButtonGroup,
  AdvancedCaretButton,
};
